// extracted by mini-css-extract-plugin
module.exports = {"main":"ArticlesTitle_main__bwJ_Q"};